import React from 'react';
import {
    CheckCircleFilled,
    ClockCircleFilled,
    CloseCircleFilled,
} from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import { TRANSACTION_STATUS } from '../treasury.constants';
import styles from './styles/pills.module.scss';

const ICONS = {
    [TRANSACTION_STATUS.COMPLETE]: <CheckCircleFilled />,
    [TRANSACTION_STATUS.PENDING]: <ClockCircleFilled />,
    [TRANSACTION_STATUS.FAILED]: <CloseCircleFilled />,
};

const LABELS = {
    [TRANSACTION_STATUS.COMPLETE]: 'Complete',
    [TRANSACTION_STATUS.PENDING]: 'Pending',
    [TRANSACTION_STATUS.FAILED]: 'Failed',
};

const TONES = {
    [TRANSACTION_STATUS.COMPLETE]: styles.statusSuccess,
    [TRANSACTION_STATUS.PENDING]: styles.statusWarning,
    [TRANSACTION_STATUS.FAILED]: styles.statusDanger,
};

/**
 * Status indicator rendered inside the "Status" column of the
 * transactions table. Per the Figma reference (node 5679:6440) the
 * status is an inline icon + label pair — no background pill or
 * border. Shares structure with `TransactionTypePill` — only the tone
 * colour differs.
 */
function TransactionStatusPill({ status }) {
    const safeStatus = status || TRANSACTION_STATUS.COMPLETE;
    const tone = TONES[safeStatus] || TONES[TRANSACTION_STATUS.COMPLETE];

    return (
        <span className={`${styles.pill} ${tone}`}>
            <span className={styles.icon} aria-hidden="true">
                {ICONS[safeStatus]}
            </span>
            <Text as="span" size="xs" className={styles.label}>
                {LABELS[safeStatus]}
            </Text>
        </span>
    );
}

export default TransactionStatusPill;
